import { render, staticRenderFns } from "./SuggestionsAlert.vue?vue&type=template&id=175e3051&scoped=true"
import script from "./SuggestionsAlert.vue?vue&type=script&lang=js"
export * from "./SuggestionsAlert.vue?vue&type=script&lang=js"
import style0 from "./SuggestionsAlert.vue?vue&type=style&index=0&id=175e3051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e3051",
  null
  
)

export default component.exports